import { render, staticRenderFns } from "./woods-form.html?vue&type=template&id=27d5799d&scoped=true&external"
import script from "./woods-form.js?vue&type=script&lang=js&external"
export * from "./woods-form.js?vue&type=script&lang=js&external"
import style0 from "./woods-form.scss?vue&type=style&index=0&id=27d5799d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5799d",
  null
  
)

export default component.exports